import React from 'react'
import Header from './header'
import Banner from './banner'
import Comparison from './comparison'
import Slot from './slot'
import Faq from './faq'
import Ready from './ready'
// import vid from "../../../videos/surge/surge.webm"
import axios from 'axios'
// import Testimonial from './testimonial'
import { Helmet } from 'react-helmet'
import Colleges from './what_is_colleges'
import WhyOwnCollegess from './why_own_colleges'
import Status from './status'
import Campus from './campus'
import Impact from './impact'
import WhyCollege from './why_workfast'
import API from '../../../utils/API'
// import Price from './price'



export default function Home() {
    const [bookedDetailes, setbookedDetails] = React.useState([]);

    const handleBookSlot = async () => {
        try {
            const { data } = await axios.get(
                API.BASE_URL + API.GET_SLOT,
            );
            setbookedDetails(data?.data || []);
        } catch (err) {
            var statusCode = err?.response?.status;
            console.log(statusCode);
        }
    };

    React.useEffect(() => {
        handleBookSlot()
    }, [])


    return (
        <div className='relative overflow-hidden'>
            <Helmet>
                {/* <!-- Google tag (gtag.js) --> */}
                <script async src="https://www.googletagmanager.com/gtag/js?id=G-BPPK98DZ10"></script>
                <script>{`window.dataLayer = window.dataLayer || []; function gtag(){dataLayer.push(arguments);} gtag('js', new Date()); gtag('config', 'G-BPPK98DZ10');`}
                </script>
            </Helmet>
            <Header />
            <Banner bookedDetailes={bookedDetailes}/>
            <Colleges />
            <WhyOwnCollegess />
            <Comparison />
            <WhyCollege />
            {/* <Price /> */}
            <Status />
            <Campus />
            <Impact />
            <Slot bookedDetailes={bookedDetailes}/>
            {/* <Testimonial /> */}
            <Faq />
            <Ready />
            {/* <Program />
            <Vision />
            <Framework />
            <Plan />
            <Slot bookedDetailes={bookedDetailes} />
            <About />
            <Testimonial />
            <Faq />
            <Ready /> */}
            <div className='border-t border-[#F3F4F6] text-[#6A7282] text-[12px] md:text-[14px] font-normal py-[20px] md:py-[42px] text-center'>© 2025 Surge Colleges · Powered by Workfast AI</div>
        </div>
    )
}
